var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-buttons-list"},_vm._l((_vm.socials),function(social,index){return _c('span',{staticClass:"transition",class:index,attrs:{"title":social},domProps:{"textContent":_vm._s(social)},on:{"click":function($event){return _vm.share(index)}}})}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ead4b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/ShareButtons.vue
// module id = nkgr
// module chunks = 2